/*
 * @Descripttion:
 * @version:
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2025-09-10 14:34:00
 */
import axios from "axios";
import { uuidv4 } from "/@/utils/uuid";
import { CURRENT_CONFIG } from "./config";
import { message } from "ant-design-vue";
import router from "/@/router";
import { ELocalStorageKey, ERouterName, EUserType } from "/@/types/enums";
import Cookies from "js-cookie";
export * from "./type";
const REQUEST_ID = "X-Request-Id";
function getAuthToken() {
  return Cookies.get(ELocalStorageKey.Token) || new Date().getTime();
  // return localStorage.getItem(ELocalStorageKey.Token)
}
const instance = axios.create({
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  // timeout: 30000, // 设置默认超时 30 秒
});

instance.interceptors.request.use(
  (config) => {
    config.headers[ELocalStorageKey.Token] = getAuthToken();
    // let onlys = getOnly()
    // if (onlys) {
    //   config.headers['only'] = onlys
    // }
    // config.headers[REQUEST_ID] = uuidv4()
    config.baseURL = CURRENT_CONFIG.baseURL;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // console.info('URL: ' + response.config.baseURL + response.config.url, '\nData: ', response.data, '\nResponse:', response)
    // console.log(54,response);

    if (response.data.code && response.data.code !== 0) {
      // message.error(response.data.message)
      if (response.data.message == "请重新登录") {
        setTimeout(() => {
          router.push(ERouterName.PROJECT);
          return;
        }, 1000);
      }
    }
    return response;
  },
  (err) => {
    // 如果是取消请求，直接抛出错误，不显示提示
    if (axios.isCancel(err) || err.name === 'AbortError' || err.name === 'CanceledError') {
      return Promise.reject(err);
    }
    
    const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID];
    if (requestId) {
      console.info(REQUEST_ID, "：", requestId);
    }
    // console.info('url: ', err?.config?.url, `【${err?.config?.method}】 \n>>>> err: `, err)
    // console.log(err, 68);

    let description = "-";
    if (err.response?.data && err.response.data.message) {
      description = err.response.data.message;
    }
    if (err.response?.data && err.response.data.result) {
      description = err.response.data.result.message;
    }
    // @See: https://github.com/axios/axios/issues/383
    if (!err.response || !err.response.status) {
      message.error("网络异常，请检查服务，然后重试");
      return Promise.reject(err);
    }
    if (err.response?.status !== 200) {
      if (err.response?.status == 401) {
        message.error(`请重新登录！`);
      } else {
        message.error(`ERROR_CODE: ${err.response?.status}`);
      }
    }
    // if (err.response?.status === 403) {
    //   // window.location.href = '/'
    // }
    if (err.response?.status === 401) {
      console.error(err.response);
      Cookies.remove(ELocalStorageKey.Token);
      Cookies.remove(ELocalStorageKey.Username);
      router.push(ERouterName.PROJECT);

      // const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
      // switch (flag) {
      //   case EUserType.Web:
      //   router.push(ERouterName.PROJECT)
      //     break
      //   case EUserType.Pilot:
      //     router.push(ERouterName.PILOT)
      //     break
      // }
    }

    return Promise.reject(err);
  }
);
// 封装上传文件的方法，添加进度处理
export const uploadProgressFile = (
  url: string,
  data: any,
  onUploadProgress: any
) => {
  return instance({
    url,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: onUploadProgress,
  });
};
export default instance;
